import { Palette } from '@common/theming/Palette';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

export const Section: React.FC<{
  title: string;
  links?: LinkProps[];
  children?: React.ReactNode;
  id: string;
}> = ({ title, children, id, links }) => (
  <div style={{ alignItems: 'flex-start', justifyContent: 'flex-start' }}>
    <div
      id={id}
      style={{
        color: Palette.WHITE_50,
        fontSize: 18,
        margin: '0 0 20px',
        textTransform: 'uppercase',
      }}>
      {title}
    </div>
    {links && (
      <div style={{ display: 'flex', gap: 30 }}>
        {links.map((link) => (
          <Link
            to={'/layouts/full-screen-fixed-header'}
            style={{
              color: Palette.WHITE_30,
              textTransform: 'none',
            }}>
            {link.children}
          </Link>
        ))}
      </div>
    )}
    <div
      style={{
        margin: '0 0 20px',
        textTransform: 'uppercase',
      }}>
      {children}
    </div>
  </div>
);
